import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import  { useState , useEffect } from "react";
import {  faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Button,  Modal, Spinner } from 'react-bootstrap';
import RegisterTextbox from '../../components/RegisterTextBox';
import TableComponent from '../../components/TableComponent';
import API from '../../api/axiosConfig';
import { useNavigate , useParams } from 'react-router';
import TestPreLoader from '../TestPreLoader/TestPreLoader';
import RegisterSelect from '../../components/RegisterSelect';


function ProjectMember() {
    const columns = [
        { name: "اسم المسئول", key: "responsible_name" },
        { name: "اسم المرحلة", key: "phase_name" },
        { name: "نوع المسئول", key: "responsible_type_string" },
        { name: "الدور", key: "role" },
        { name: "المهام", key: "responsibility" },


        { name: "", key: "actions" },
    ];
    const [rows, setRows] = useState([])
    const [error, setError] = useState([])
    const [name, setName] = useState('')
    const [title, setTitle] = useState('')
    const [task, setTask] = useState('')
    const [showModal, setShowModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [tableReloadKey, setTableReloadKey] = useState(Date.now());
    const [phase , setPhase] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message , setMessage] = useState('');
    const [phases, setPhases] = useState('');
    const navigate = useNavigate();
    const { id } = useParams();
    const [employees , setEmployees] = useState([]);
    const [volunteers , setVolunteers] = useState([]);
    const [showemployeeselect , setShowEmployeesSelect] = useState(false);
    const [showvolunteerselect , setShowVolunteerSelect] = useState(false);
    const [type , setType] = useState('');
    const [employeesValue , setEmployeesValue] = useState('');
    const [volunteersValue , setVolunteersValue] = useState('');
    const [responsibility , setResponsibility] = useState('');
    const [role , setRole] = useState('');

   
    const handleArchive = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const formData = new FormData();
        formData.append('responsible_type', type);
        formData.append('responsible_id', type === "1" ? employeesValue : volunteersValue);
        formData.append('responsibility', responsibility);
        formData.append('project_id', id);
        formData.append('phase_id', phases);
        formData.append('role', role);


        try {
            const res = await API.post(`/projectassignment/store`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const data = await res;
            if (data.status === 200) {
                setName('');
                setTitle('');
                setTask('');
                setError([]);

                setShowModal(false);
                setIsSubmitting(false);
                setRows(data.data);
                setTableReloadKey(Date.now());
            }
        } catch (error) {
            console.error(error);
            setIsSubmitting(false);
            setError(error.response?.data?.errors || {});
        }
    };

     const getPhases = async () => {
        try {
            const response = await API.get(`/projectphase/${id}/all`);
            const data = await response;
            setPhase(data.data);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setError(error.response.data.errors);
            setMessage(error.response.data.message);
        }
    };

    const getallEmployees = async () => {
        try {
            const response = await API.get(`/employees/all`);
            const data = await response;
            setEmployees(data.data);
            setLoading(false);
            setShowEmployeesSelect(true);
        } catch (error) {
            console.log(error);
            setError(error.response.data.errors);
            setMessage(error.response.data.message);
        }
    };

    const getAllVolunteers = async () => {
        try {
            const response = await API.get(`/volunteers/all`);
            const data = await response;
            setVolunteers(data.data);
            setLoading(false);
            setShowVolunteerSelect(true);
        } catch (error) {
            console.log(error);
            setError(error.response.data.errors);
            setMessage(error.response.data.message);
        }
    };

    useEffect(() => {
        getPhases();
        getallEmployees();
        getAllVolunteers();
    }, []);

    const dropdownOptions = [
        { label: "حذف", action: (id) => {
            if (window.confirm("هل أنت متأكد من حذف هذا المسئول؟")) {
                API.get(`/projectassignment/${id}/delete`)
                    .then((res) => {
                        if (res.status === 200) {
                            setTableReloadKey(Date.now());
                        }
                    })
                    .catch((error) => {
                        console.error("There was an error!", error);
                    });
            }
        } },
    ];


    const handleTypeChange = (e) => {
        setShowEmployeesSelect(false);
        setShowVolunteerSelect(false);
        const value = e.target.value;
         setType(value);
        if (value === '1') {
            setShowEmployeesSelect(true);
            setShowVolunteerSelect(false);
        }else {
            setShowVolunteerSelect(true);
            setShowEmployeesSelect(false);
        }
    };

        if (loading) return <TestPreLoader />;

    return (
        <>
            <div className="printcasedata-container">

                <div className="archive-report">
                    <span className="add-row-ta archiveAdd" onClick={() => setShowModal(true)}>
                        <FontAwesomeIcon icon={faPlus} /> إضافة
                    </span>
                </div>

                <TableComponent
                    apiUrl={`/projectassignment/${id}`}
                    columns={columns}
                    title="اعضاء المشروع"
                    triggerReload={tableReloadKey}
                    dropdownOptions={dropdownOptions}
                />
            </div>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                className="modal-table small-modall archModal archive-modal"
                  dialogClassName="fit-content-modal"

            >
                <Modal.Header>
                    <Modal.Title>إضافة مسئول</Modal.Title>
                    <Button
                        className="custom-close-button"
                        variant="link"
                        onClick={() => setShowModal(false)}
                    >
                        <FontAwesomeIcon icon={faXmark} className="closeModal" />
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <RegisterSelect id="type"
                                        label="النوع"
                                        stylee={{ width: "100%" }}
                                        parentStyle={{ width: "80%" }}
                                        options={[
                                            { value: "", label: " اختر  النوع " },
                                            { value: "1", label: "موظف" },
                                            { value: "2", label: "متطوع" },
                                        ]}
                                        name="type"
                                        value={type}
                                        onChange={handleTypeChange}
                                    />
                     <RegisterSelect id="phase"
                                      label="المرحلة"
                                      stylee={{ width: "100%" }}
                                      parentStyle={{ width: "80%" }}
                                      options={[
                                        { value: "", label: " اختر  المرحلة " },
                                        ...phase.map((p) => ({ value: p.id, label: p.name }))
                                        
                                      ]}
                                      name="phases"
                                      value={phases}
                                      onChange={(e) => setPhases(e.target.value)}
                                    />
                                    {showemployeeselect && (
                                        <RegisterSelect id="employee"
                                            label="الموظفين"
                                            stylee={{ width: "100%" }}
                                            parentStyle={{ width: "80%" }}  
                                            options={[
                                                { value: "", label: " اختر  الموظف " },
                                                ...employees.map((e) => ({ value: e.id, label: e.name }))
                                                
                                              ]}
                                            name="employees"
                                            value={employeesValue}
                                            onChange={(e) => setEmployeesValue(e.target.value)}
                                        />
                                    )}
                                    {showvolunteerselect && [
                                        <RegisterSelect id="volunteer"
                                      label="المتطوعين"
                                      stylee={{ width: "100%" }}
                                      parentStyle={{ width: "80%" }}
                                      options={[
                                        { value: "", label: " اختر  المتطوع " },
                                        ...volunteers.map((v) => ({ value: v.id, label: v.name }))
                                        
                                      ]}
                                      name="volunteers"
                                      value={volunteersValue}
                                      onChange={(e) => setVolunteersValue(e.target.value)}
                                    />
                                            ]}
                                    
                    <RegisterTextbox label="الادوار" type="text" value={role} onChange={(e) => setRole(e.target.value)} />
                    {error && error.role && <span className="error">{error.role[0]}</span>}
                    <RegisterTextbox label="المسئوليات" type="text" value={responsibility} onChange={(e) => setResponsibility(e.target.value)} />
                    {error && error.responsibility && <span className="error">{error.responsibility[0]}</span>}
                    
                   

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        إغلاق
                    </Button>
                    {
                        isSubmitting ? (
                            <Button variant="primary" disabled>
                                <Spinner animation="border" size="sm" />
                            </Button>
                        ) : (
                            <Button variant="primary" onClick={handleArchive}>
                                حفظ
                            </Button>
                        )
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ProjectMember;
